const Entity = ({ row, Row }) => {
  if (!row || row.visibility === "collapsed") return null;

  return (
    <div style={{ position: "relative", display: "inline-table" }}>
      {row.label && <h1 className="font-18 pad-5">{row.label}</h1>}
      <div className="entity-section">
        {row.entities.map((entity, entityIdx) => (
          <div key={entityIdx} className="entity-wrapper border-green">
            <span className="entity-label">
              {row.label
                ? `${row.label} ${entityIdx + 1}`
                : `Entity ${entityIdx + 1}`}
            </span>

            <div className="entity-content">
              {entity.map((childRow, childIdx) => (
                <div key={childIdx}>{Row(childRow)}</div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Entity;
